import { ChatCopyGuest } from '@commons/chat-assistance/models/chat-copy-guest';

export class ChatCopyMessage {
  public content: string;
  public copy: ChatCopyGuest;
  public isFullCopy: boolean;

  constructor(content: string, copy: ChatCopyGuest, isFullCopy: boolean = false) {
    this.content = content;
    this.copy = copy;
    this.isFullCopy = isFullCopy;
  }
}
